import { useNavigate } from 'react-router-dom'

import { UserIcon } from '@buffer-mono/popcorn'

import {
  useAccount,
  useCanStartTrial,
  useIsFreeUser,
} from '~publish/contexts/AccountContext'
import { isEssentialsUser } from '~publish/helpers/user'
import { settingsBillingRoute, settingsTeamRoute } from '~publish/legacy/routes'
import { MODALS, useOpenGlobalModal } from '~publish/hooks/useOpenGlobalModal'
import { isTeamPlan } from '~publish/pages/Settings/Billing/utils/planUtils'

import { TaskCard } from './TaskCard'
import { useInviteTeamStatus } from './useTaskCardStatus'

import type { JSX } from 'react'

const CTA = 'publish-home-firstSteps-inviteTeam-1'

export function InviteTeamCard(): JSX.Element {
  const navigate = useNavigate()
  const { account } = useAccount()
  const isFreeUser = useIsFreeUser()
  const canStartTrial = useCanStartTrial()
  const openGlobalModal = useOpenGlobalModal()
  const isEssentials = isEssentialsUser(account)
  const isTeam = account && isTeamPlan(account)
  const { status, markComplete } = useInviteTeamStatus()

  const handleInviteTeam = (): void => {
    if (isTeam) {
      navigate(settingsTeamRoute.route)
      return
    }

    if (isFreeUser) {
      if (canStartTrial) {
        openGlobalModal(MODALS.startTrial, {
          cta: CTA,
          upgradePathName: 'inviteTeam-trial',
        })
      } else {
        openGlobalModal(MODALS.planSelector, {
          cta: CTA,
          upgradePathName: 'inviteTeam-upgrade',
        })
      }
      return
    }

    if (isEssentials) {
      navigate(settingsBillingRoute.route)
      return
    }

    navigate(settingsTeamRoute.route)
  }

  return (
    <TaskCard status={status}>
      <TaskCard.CompleteAction onClick={markComplete} />
      <TaskCard.Header>
        <TaskCard.Title>3. Part of a team?</TaskCard.Title>
      </TaskCard.Header>
      <TaskCard.Description>
        Invite your team and try our collaboration features on the team plan.
      </TaskCard.Description>
      <TaskCard.Footer>
        <TaskCard.PrimaryAction onClick={handleInviteTeam}>
          <UserIcon />
          Invite
        </TaskCard.PrimaryAction>
        <TaskCard.CompletedLabel>Team Invited</TaskCard.CompletedLabel>
      </TaskCard.Footer>
    </TaskCard>
  )
}
